import React from 'react';
import ReactDOM from 'react-dom/client';
// router
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Tracing
// import reportWebVitals from './reportWebVitals';

// Amplify
import { Amplify } from 'aws-amplify';
import environment from './settings/environmentLoader';
Amplify.configure(environment.Amplify);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
